import React from 'react';
import Rodal from '../../components/Rodal/Rodal';
import './AudioPlayerPopup.scss';
import { ModalBody, ModalHeader } from 'reactstrap';

interface AudioPlayerPopupProps {
    title: string;
    src: string;
    onClose(): void;
    hideContextMenu?: boolean;
}

export const AudioPlayerPopup = (props: AudioPlayerPopupProps) => {
    const audioRef = React.useRef<HTMLAudioElement>(null);
    const hideContextMenu = props.hideContextMenu || false;

    React.useEffect(() => {
        if (audioRef.current && hideContextMenu) {
            const audioElement = audioRef.current;
            
            audioElement.addEventListener('contextmenu', (e) => {
                e.preventDefault();
                return false;
            });
            
            audioElement.setAttribute('oncontextmenu', 'return false;');
            
            const controlsList = audioElement.getAttribute('controlsList');
            if (!controlsList || !controlsList.includes('nodownload')) {
                audioElement.setAttribute('controlsList', 'nodownload nofullscreen noremoteplayback');
            }
        }
    }, [hideContextMenu]);

    return (
        <div className="audio-player-popup">
            <Rodal
                showMask={true}
                width={1000}
                visible={true}
                animation={'slideRight'}
                onClose={() => props.onClose()}
                closeMaskOnClick={false}
                center>
                <ModalHeader>{props.title}</ModalHeader>
                <ModalBody>
                    <div className="audio-player-container">
                        <audio
                            ref={audioRef}
                            controls
                            controlsList={hideContextMenu ? 'nodownload nofullscreen noremoteplayback' : undefined}
                            style={{ width: '100%' }}
                            src={props.src}>
                            Your browser does not support the audio element.
                        </audio>
                    </div>
                </ModalBody>
            </Rodal>
        </div>
    );
};

export default AudioPlayerPopup;

